export const deleteCommentResponse = (id: string) => ({
  deleteComment: {
    id,
    __typename: 'Comment',
  },
});
